module.exports = "img/37.e37ca1.webp";